<template>
    <div class="club-step__billing-message">
        <div>

            <p>Your selection is almost ready!</p>
            <a :href="link"
                class="btn-primary"
                >Add your credit card to complete it</a
            >
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "BillingMessage",
    data() {
        return {
            link: `${window.location.origin}/shop/billing?builder=1`,
        };
    },
    methods: {
        ...mapActions(["goToUpdateBilling"]),
    },
};
</script>
